export const EDD_VERSION = 'V4';

export enum EddYesNo {
  YES = 'YES',
  NO = 'NO',
}
